module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_16.6344ea13.jpg";